import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateChatWidgetIcon as UpdateChatWidgetIconMutation,
    UpdateChatWidgetIconVariables as UpdateChatWidgetIconMutationVariables,
    ChatWidgetIconUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_CHAT_WIDGET_ICON from '../mutations/update-chat-widget-icon.graphql';

export const useUpdateChatWidgetIcon = (): {
    updateChatWidgetIcon: (input: ChatWidgetIconUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateChatWidgetIcon, {loading, error}] = useMutation<
        UpdateChatWidgetIconMutation,
        UpdateChatWidgetIconMutationVariables
    >(UPDATE_CHAT_WIDGET_ICON);

    return {
        updateChatWidgetIcon: (input: ChatWidgetIconUpdateInput) => {
            return updateChatWidgetIcon({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
